var _linearGradient, _linearGradient2, _clipPath, _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSl6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 127 24",
    width: 127,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 16.4461,
    x2: 16.4461,
    y1: 1.85156,
    y2: 10.9627
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#04bf50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c451"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 16.4461,
    x2: 16.4461,
    y1: 21.8513,
    y2: 12.7402
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b0c8d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a6c2d0"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h127v24h-127z"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "d",
    height: 24,
    maskUnits: "userSpaceOnUse",
    width: 127,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "m127 0h-127v24h127z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1 6.45156c0-1.62712 0-2.44068.32168-3.05993.27107-.52184.69656-.94732 1.21839-1.2184.61926-.32167 1.43281-.32167 3.05993-.32167h4.20445c.10847 0 .16271 0 .20395.02144.0348.01807.0632.04644.0813.08123.0214.04128.0214.09552.0214.20399v19.38668c0 .1085 0 .1628-.0214.204-.0181.0348-.0465.0632-.0813.0813-.04124.0214-.09548.0214-.20395.0214h-4.20445c-1.62712 0-2.44067 0-3.05993-.3217-.52183-.271-.94732-.6965-1.21839-1.2184-.32168-.6192-.32168-1.4328-.32168-3.0599z",
    fill: "#6c8aa2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.0017 6.45156c0-1.62712 0-2.44068-.3217-3.05993-.271-.52184-.6965-.94732-1.2184-1.2184-.6192-.32167-1.4328-.32167-3.0599-.32167h-4.2044c-.1085 0-.1628 0-.204.02144-.0348.01807-.0632.04644-.0813.08123-.0214.04128-.0214.09552-.0214.20399v8.49788c0 .1084 0 .1627.0214.2039.0181.0348.0465.0632.0813.0813.0412.0214.0955.0214.204.0214h8.4977c.1085 0 .1627 0 .204-.0214.0348-.0181.0632-.0465.0813-.0813.0214-.0412.0214-.0955.0214-.2039z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.0017 18.9942c0 1.5779-1.2792 2.8571-2.8571 2.8571h-6.0635c-.1052 0-.1905-.0853-.1905-.1905v-8.7301c0-.1052.0853-.1905.1905-.1905h8.7301c.1052 0 .1905.0853.1905.1905z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "m49.6199 12.8279v-.748h-6.908v2.75h3.476c-.462 1.496-1.87 2.42-3.784 2.42-2.288 0-4.158-1.782-4.158-4.972 0-3.07996 1.892-4.88396 4.136-4.88396.99 0 1.826.264 2.486.792.682.528 1.1 1.122 1.298 1.76l3.146-.924c-.902-2.97-3.564-4.686-6.93-4.686-4.07 0-7.546 2.926-7.546 7.94196 0 5.104 3.52 7.986 7.568 7.986 3.674 0 7.216-2.31 7.216-7.436z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.7101 20.2418c2.86 0 5.632-2.068 5.632-5.786 0-3.696-2.684-5.69799-5.632-5.69799-2.838 0-5.632 2.00199-5.632 5.69799 0 3.784 2.684 5.786 5.632 5.786zm0-2.794c-1.254 0-2.42-1.056-2.42-2.992s1.166-2.904 2.42-2.904 2.42.99 2.42 2.904c0 1.958-1.122 2.992-2.42 2.992z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.2336 20.2418c2.86 0 5.632-2.068 5.632-5.786 0-3.696-2.684-5.69799-5.632-5.69799-2.838 0-5.632 2.00199-5.632 5.69799 0 3.784 2.684 5.786 5.632 5.786zm0-2.794c-1.254 0-2.42-1.056-2.42-2.992s1.166-2.904 2.42-2.904 2.42.99 2.42 2.904c0 1.958-1.122 2.992-2.42 2.992z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.1388 19.9991h2.948v-15.79598h-3.168v5.522c-.704-.55-1.65-.92399-2.772-.92399-2.552 0-4.928 1.91397-4.928 5.67597 0 3.784 2.398 5.698 4.95 5.698 1.232 0 2.266-.528 2.97-1.232zm-4.708-5.522c0-1.958 1.078-2.86 2.31-2.86s2.156.858 2.178 2.178v1.342c-.022 1.408-1.012 2.222-2.178 2.222-1.232 0-2.31-.88-2.31-2.882z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.8594 19.9996h5.478c3.784 0 7.3916-2.508 7.3916-7.81 0-5.16999-3.5856-7.58999-7.3696-7.58999h-5.5zm3.278-2.904v-9.59199h2.002c1.232 0 2.244.418 3.014 1.276.77.836 1.166 1.97999 1.166 3.40999 0 3.102-1.65 4.906-4.114 4.906z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.858 19.0524.066-.066.022 1.012h3.036v-7.238c0-2.618-1.826-4.02602-4.752-4.02602-2.354 0-4.312 1.05599-4.928 3.08002l2.772.748c.286-.858.99-1.32 2.024-1.32.99 0 1.694.418 1.804 1.276l-3.036.792c-2.442.638-3.718 1.584-3.718 3.454 0 2.134 1.76 3.454 3.762 3.454 1.122 0 2.046-.374 2.948-1.166zm-3.564-2.486c0-.726.594-1.034 1.848-1.386l1.76-.484-.022 2.068-.594.374c-.638.418-1.078.594-1.628.594-.638 0-1.364-.374-1.364-1.166z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m125.721 9.04297h-3.124l-2.178 5.61003-2.31-5.61003h-3.234l3.938 8.99803-2.508 6.138h3.08z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSl6);
export default __webpack_public_path__ + "static/media/sl6.41fd74edb8d7483c10cdb8bcc828a98e.svg";
export { ForwardRef as ReactComponent };